import styled from 'src/styles/theme';
import { selectButton } from '@components/Modal/ModalComparators/shared/OV';
import { ModalTrimStyled } from '../ModalTrimStyled';
import { rem } from 'polished';

export const ModalTrimStyledOV = styled(ModalTrimStyled)`
    .sticky {
        background: ${({ theme }) => theme.colors.pureWhite};

        .trim {
            background: ${({ theme }) => theme.colors.pureWhite};
        }
    }

    .trims {
        .sections {
            .trim {
                .trimImage {
                    width: ${rem(270)};
                }

                button {
                    ${selectButton}
                }
            }
        }
    }

    .enginesAvailable,
    .stylesAvailable,
    .colors,
    .interiorsAvailable,
    .featuresAvailable {
        .label {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .colors {
        .configurations {
            img {
                width: ${rem(270)};
            }

            button {
                &.selected,
                &:hover {
                    box-shadow: 0px 0px 0px 0.1rem ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .categories {
        span {
            background: ${({ theme }) => theme.colors.pureWhite};
            color: ${({ theme }) => theme.colors.black};
            border-color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &.selected,
            &:hover {
                background: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }
`;
